import React from "react";

import './gallery.css';

function Gallery() {
    return (
        <div className="wrap">
            <div className="baris gx-0">
                <img src={require("../../photo/IMG-9757.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-9756.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-9985.jpg")} className="gambar1"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/IMG-0051.jpg")} className="gambar2"></img>
                <img src={require("../../photo/IMG-0049.jpg")} className="gambar2"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/IMG-9982(1).jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0052.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0050.jpg")} className="gambar1"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/IMG-9948.jpg")} className="gambar2"></img>
                <img src={require("../../photo/IMG-0048.jpg")} className="gambar2"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/TGRI/1.jpg")} className="gambar1"></img>
                <img src={require("../../photo/TGRI/2.jpg")} className="gambar1"></img>
                <img src={require("../../photo/TGRI/3.jpg")} className="gambar1"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/TGRI/4.jpg")} className="gambar2"></img>
                <img src={require("../../photo/TGRI/6.jpg")} className="gambar2"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/IMG-0173.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0175.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0177.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0174.jpg")} className="gambar1"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/TGRI/7.jpg")} className="gambar2"></img>
                <img src={require("../../photo/TGRI/8.jpg")} className="gambar2"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/IMG-0621.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0615.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0608.jpg")} className="gambar1"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/IMG-0687.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0686.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0683.jpg")} className="gambar1"></img>
                <img src={require("../../photo/IMG-0685.jpg")} className="gambar1"></img>
            </div>
            <div className="baris gx-0">
                <img src={require("../../photo/ascop2.JPG")} className="gambar2"></img>
                <img src={require("../../photo/IMG-0292.jpg")} className="gambar2"></img>
            </div>
        </div>
    )
};

export default Gallery;